import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select'
import { currentDateAndTime, decodeData } from '../../Constants/constants';
class CalendarFestivals extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            calendar_festival_id: 0,
            filter_calendar_festivals_state_id: '',
            calendar_id: 0,
            calendar_festivals_state_id: 0,
            calendar_festivals_type: '1',
            filter_calendar_id: 0,
            calendar_festivals_name: '',
            calendar_festival_date: '',
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 40,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            get_calendars_rows: [],
            get_state_rows: [],
            errors: {},
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetCalendarFestivals();
            this.GetList();
            this.GetState();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    GetCalendarFestivals = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Masters/GetCalendars`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    const getCalendarsRows = data.data.map((row) => ({
                        value: row.calendar_id,
                        fromDate: row.from_date ? new Date(row.from_date) : null,
                        toDate: row.to_date ? new Date(row.to_date) : null,
                        label: (
                            <span>
                                {formatDate(row.from_date)} <i className="ri-arrow-left-right-line" /> {formatDate(row.to_date)}
                            </span>
                        ),
                    }));

                    this.setState({
                        get_calendars_rows: getCalendarsRows,
                    }, this.filterCurrentYear);
                }
            });
    }
    
    
    GetState = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetStateList`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        get_state_rows: data.data.map((row) => ({
                            value: row.state_id,
                            label: row.state_title,
                        }))
                    }));
                }
            });
    }


    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCalendarFestivalInfo?calendar_festival_id=${this.state.calendar_festival_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        calendar_festivals_name: data[0].calendar_festivals_name,
                        calendar_id: data[0].calendar_id,
                        calendar_festivals_state_id: data[0].calendar_festivals_state_id,
                        calendar_festival_date: data[0].calendar_festival_date,
                        calendar_festivals_type: data[0].calendar_festivals_type.toString(),
                        // errors: {
                        //         ...this.state.errors 

                        // }

                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCalendarFestivals`, {
            params: {
                filter_calendar_festivals_state_id: this.state.filter_calendar_festivals_state_id,
                filter_calendar_id: this.state.filter_calendar_id,
                limit: this.state.limit,
                page: this.state.page
            }, headers
        }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
                this.GetState();
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            calendar_id: this.state.calendar_id,
            calendar_festivals_state_id: this.state.calendar_festivals_state_id,
            calendar_festivals_name: this.state.calendar_festivals_name,
            calendar_festivals_type: this.state.calendar_festivals_type,
            calendar_festival_date: this.state.calendar_festival_date,
            date: currentDateAndTime(),
        };
        if (this.state.calendar_festival_id !== 0) {
            formData.calendar_festival_id = this.state.calendar_festival_id;
        }

        axios
            .post(`${apiURL}Masters/CreateCalendarFestival`, formData, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    this.resetForm();

                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                }

            })
    };
    resetForm = () => {
        this.setState({
            calendar_festival_id: 0,
            calendar_id: 0,
            calendar_festivals_state_id: 0,
            calendar_festivals_type: '1',
            calendar_festivals_name: '',
            calendar_festival_date: '',
        })

    }


    filterCurrentYear = () => {
        const currentYear = new Date().getFullYear();
        const currentCalendar = this.state.get_calendars_rows.find(row =>
            row.fromDate.getFullYear() <= currentYear && row.toDate.getFullYear() >= currentYear
        );
        let states = this.state.get_state_rows[0];

        this.setState({
            filter_calendar_id: currentCalendar ? currentCalendar.value : null,
            filter_calendar_festivals_state_id: states ? states.value : null,
        }, () => {
            this.GetList();
        });
    }

    handleInputSearch = (e) => {
        this.GetList();
    }


    validateForm() {
        const errors = {};

        if (this.state.calendar_id === 0) {
            errors.calendar_id = 'Select calendar is required';
        }
        if (this.state.calendar_festivals_state_id === 0) {
            errors.calendar_festivals_state_id = 'Select State is required';
        }
        if (!this.state.calendar_festivals_name) {
            errors.calendar_festivals_name = 'Holiday name is required';
        }
        if (!this.state.calendar_festival_date) {
            errors.calendar_festival_date = 'Holiday date is required';
        }

        return errors;
    }

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    calendar_festival_id: id,
                    date: currentDateAndTime(),
                };
                axios
                    .post(`${apiURL}Masters/DeleteCalendarFestival`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Holidays`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Holidays</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label>Select Calendar</label>
                                                        <Select
                                                            onChange={(selectedOption) => this.handleSelectChange('calendar_id', selectedOption)}
                                                            value={this.state.calendar_id ? this.state.get_calendars_rows.find(option => option.value === this.state.calendar_id) : null}
                                                            placeholder={`Select Calendar`}
                                                            isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            options={this.state.get_calendars_rows}
                                                        />
                                                        {errors.calendar_id && <div className="text-danger">{errors.calendar_id}</div>}
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label>Select State</label>
                                                        <Select
                                                            onChange={(selectedOption) => this.handleSelectChange('calendar_festivals_state_id', selectedOption)}
                                                            value={this.state.calendar_festivals_state_id ? this.state.get_state_rows.find(option => option.value === this.state.calendar_festivals_state_id) : null}
                                                            placeholder={`Select State`}
                                                            isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            options={this.state.get_state_rows}
                                                        />
                                                        {errors.calendar_festivals_state_id && <div className="text-danger">{errors.calendar_festivals_state_id}</div>}
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="calendar_festivals_name" className="form-label">Holiday Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.calendar_festivals_name ? 'is-invalid' : ''}`}
                                                            id="calendar_festivals_name"
                                                            name="calendar_festivals_name"
                                                            value={this.state.calendar_festivals_name}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Holiday Name"
                                                        />
                                                        {errors.calendar_festivals_name && <div className="text-danger">{errors.calendar_festivals_name}</div>}

                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="calendar_festival_date" className="form-label">Holiday Date</label>
                                                        <input
                                                            type="date"
                                                            className={`form-control ${errors.calendar_festival_date ? 'is-invalid' : ''}`}
                                                            id="calendar_festival_date"
                                                            name="calendar_festival_date"
                                                            value={this.state.calendar_festival_date}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Effective Date"
                                                        />
                                                        {errors.calendar_festival_date && <div className="text-danger">{errors.calendar_festival_date}</div>}

                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <div>
                                                            <label htmlFor="calendar_festivals_type" className="form-label">Holiday Type:</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2" >
                                                            <input
                                                                type="radio"
                                                                id="calendar_festivals_type1"
                                                                name="calendar_festivals_type"
                                                                value="1"
                                                                checked={this.state.calendar_festivals_type === '1'}
                                                                onChange={() => this.handleRadioChange('calendar_festivals_type', '1')}
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                className={`form-check-input ${errors.calendar_festivals_type ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="calendar_festivals_type1" className="form-check-label">Fixed Holiday</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="calendar_festivals_type0"
                                                                name="calendar_festivals_type"
                                                                value="0"
                                                                checked={this.state.calendar_festivals_type === '2'}
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                onChange={() => this.handleRadioChange('calendar_festivals_type', '2')}
                                                                className={`form-check-input ${errors.calendar_festivals_type ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="calendar_festivals_type0" className="form-check-label">Flexible Holiday</label>
                                                        </div>
                                                    </div>
                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && ( 
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.calendar_festival_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.calendar_festival_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.calendar_festival_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)

                                                        }

                                                        {
                                                            this.state.calendar_festival_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className='card'>
                                    <div className="card-header align-items-center d-flex">
                                        <div className='row'>
                                            <div className='col-md-5'>
                                                <Select
                                                    onChange={(selectedOption) => this.handleSelectChange('filter_calendar_id', selectedOption)}
                                                    value={this.state.filter_calendar_id ? this.state.get_calendars_rows.find(option => option.value === this.state.filter_calendar_id) : null}
                                                    placeholder={`Select Calendar`}
                                                    options={this.state.get_calendars_rows}
                                                />
                                            </div>
                                            <div className='col-md-5'>
                                                <Select
                                                    onChange={(selectedOption) => this.handleSelectChange('filter_calendar_festivals_state_id', selectedOption)}
                                                    value={this.state.filter_calendar_festivals_state_id ? this.state.get_state_rows.find(option => option.value === this.state.filter_calendar_festivals_state_id) : null}
                                                    placeholder={`Select State`}
                                                    options={this.state.get_state_rows}
                                                />
                                            </div>
                                            <div className='col-md-2'>
                                                <button type="button" className='btn btn-info' onClick={this.handleInputSearch}>Filter</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    {/* <th>Calendar </th> */}
                                                    <th>State Title</th>
                                                    <th>Holidays Name</th>
                                                    <th>Holidays Date</th>
                                                    <th>Holidays Type</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr>
                                                            {/* <td>{formatDate(row.calendar_label[0].calendar_from_date)}<i className="ri-arrow-left-right-line mx-2" />{formatDate(row.calendar_label[0].calendar_to_date)}</td> */}
                                                            <td>{row.state_title}</td>
                                                            <td>{row.calendar_festivals_name}</td>
                                                            <td>{formatDate(row.calendar_festival_date)}</td>
                                                            <td>{row.calendar_festivals_type_label}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && ( 
                                                                <button type='button' onClick={() => this.setState({ calendar_festival_id: row.calendar_festival_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && ( 
                                                                <button onClick={() => this.handleDelete(row.calendar_festival_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning d-none btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    // <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                    <small>Total Records: {this.state.total_records}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2 d-none'>
                                                                <select className="form-select " onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary d-none btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(CalendarFestivals);



